module.exports = __webpack_public_path__ + "img/message-green.58563258.svg";